module.exports = __webpack_public_path__ + "img/thunderboar_rush.36b0f871.png";